import React from 'react';
import { V12FinanceTerm, HitachiFinanceTerm } from '../../types';

interface FinanceTermsSliderProps {
  terms: (V12FinanceTerm | HitachiFinanceTerm)[];
  selectedTerm: V12FinanceTerm | HitachiFinanceTerm;
  setSelectedTerm: (term: V12FinanceTerm | HitachiFinanceTerm) => void;
  disabled: boolean;
}

function FinanceTerms({ terms, selectedTerm, setSelectedTerm, disabled }: FinanceTermsSliderProps): React.ReactElement {
  return (
    <div className={`finance-terms ${disabled ? 'finance-terms--disabled' : ''}`}>
      <div className="finance-terms__frame-wrapper">
        <div className="finance-terms__frame">
          {(terms as (V12FinanceTerm | HitachiFinanceTerm)[]).map((term, index) => (
            <button
              type="button"
              disabled={disabled}
              key={`${term.term}${'minDepositAmount' in term ? term.minDepositAmount : ''}${
                'maxDepositAmount' in term ? term.maxDepositAmount : ''
              }${index + 1}`}
              className={`finance-term ${term === selectedTerm ? 'finance-term--active' : ''}`}
              onClick={(): void => {
                setSelectedTerm(term);
              }}
            >
              <div className="finance-term__number">{term.term}</div>
              <div className={`finance-term__apr ${term === selectedTerm ? '' : 'hide-visibility'}`}>
                {term.apr}% APR
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FinanceTerms;
